module.exports = __webpack_public_path__ + "c2b0819b409eb7b9fbf5bf39e8f76126.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/BuyButton/430-bottle.svg
// module id = 408
// module chunks = 0